export default __webpack_public_path__ + "static/media/chest-logo-gray-500.8c5baea1.svg";